class Slider {
  constructor(containerSelector) {
    this.container = containerSelector;
    this.testimonials = this.container.querySelectorAll(".testimonial");
    this.controls = null;
    this.currentSlideIndex = 0;

    if (this.testimonials.length <= 1) {
      this.showSingleTestimonial();
      return; // Exit the constructor if there is only one or zero testimonials
    }

    this.init();
  }

  init() {
    this.createControls();
    this.attachListeners();
    this.toggleActiveSlide(0);
  }

  createControls() {
    this.controls = document.createElement("ul");
    this.controls.className = "testimonial-container__controls";
    this.controls.innerHTML =
      "<li>" +
      '<button type="button" class="testimonial-container__btn-prev">' +
      '<span class="visually-hidden">Previous</span>' +
      "</button>" +
      "</li>" +
      "<li>" +
      '<button type="button" class="testimonial-container__btn-next">' +
      '<span class="visually-hidden">Next</span>' +
      "</button>" +
      "</li>";

    this.container.appendChild(this.controls);
  }

  attachListeners() {
    const prevBtn = this.controls.querySelector(".testimonial-container__btn-prev");
    const nextBtn = this.controls.querySelector(".testimonial-container__btn-next");

    prevBtn.addEventListener("click", () => {
      this.prevSlide();
    });

    nextBtn.addEventListener("click", () => {
      this.nextSlide();
    });
  }

  nextSlide() {
    this.currentSlideIndex++;
    if (this.currentSlideIndex >= this.testimonials.length) {
      this.currentSlideIndex = 0;
    }
    this.toggleActiveSlide(this.currentSlideIndex);
  }

  prevSlide() {
    this.currentSlideIndex--;
    if (this.currentSlideIndex < 0) {
      this.currentSlideIndex = this.testimonials.length - 1;
    }
    this.toggleActiveSlide(this.currentSlideIndex);
  }

  toggleActiveSlide(index) {
    this.testimonials.forEach((testimonial, i) => {
      if (i === index) {
        testimonial.style.opacity = "1";
        testimonial.style.transition = "opacity 0.5s ease-in";
      } else {
        testimonial.style.opacity = "0";
        testimonial.style.transition = "opacity 0.5s ease-out";
      }
    });
  }

  showSingleTestimonial() {
    this.testimonials[0].style.opacity = "1";
  }
}

export function activateSlider(containerSelector) {
  const testimonials = containerSelector.querySelectorAll(".testimonial");

  if (testimonials.length > 1) {
    new Slider(containerSelector);
  } else if (testimonials.length === 1) {
    testimonials[0].style.display = "block";
    testimonials[0].style.opacity = "1";
  }
}
